import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=0ead5f80&scoped=true&"
import script from "./CloseButton.vue?vue&type=script&lang=js&"
export * from "./CloseButton.vue?vue&type=script&lang=js&"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=0ead5f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead5f80",
  null
  
)

export default component.exports